import { useState, useEffect, useContext } from 'react'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'
import { WhichWeightAPI } from 'WhichWeightAPI'
import MediumLoadingComponent from 'components/Loading/MediumLoadingComponent'

import OutlineButton from 'components/Buttons/OutlineButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function CurrentExerciseInstructionsModalRouteView() {

    const { setModalRoute, currentExercise, setCurrentExercise, setExerciseSwapIndices} = useContext(WorkoutOverrideModalContext)

    const [exerciseInstructions, setExerciseInstructions] = useState(null)

    const GetInstructionsFromBackend = async () => {
        setExerciseInstructions(null)
        
        const jsonBody = {
            exerciseId: currentExercise.id,
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('CORE', 'GET', '/exercise_instructions', jsonBody)

        // console.log(result.data.data);
        
        setExerciseInstructions(result.data.data)
    }

    const OnBackButton = () => {
        setCurrentExercise(null)
        setExerciseSwapIndices(null)
        setModalRoute('workout-template')
    }

    const OnSwapExercise = () => {
        setModalRoute('exercise-list')
    }

    useEffect(() => {
        if (currentExercise !== null && exerciseInstructions === null) {
            GetInstructionsFromBackend()
        }
    }, [currentExercise, exerciseInstructions])

    if (exerciseInstructions === null) {
        return (
            <MediumLoadingComponent />
        )
    }

    return (
        <>
            <div className="flex">
                <div className="flex-1 flex items-center h-full" />

                <h1 className="text-center px-4">{exerciseInstructions.name}</h1>

                <div className="flex-1">
                    <div className="mr-4 h-5 w-5" />
                </div>
            </div>

            <div className='h-[70vh] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] space-y-4'>
                {/* Video Instructions */}
                <div className='overflow-hidden rounded-lg bg-gray-100'>
                    {exerciseInstructions.videoURL && exerciseInstructions.videoURL.trim() !== '' ? (
                        <video 
                            width="720" 
                            height="400" 
                            controls
                            playsInline 
                            loop
                            poster={exerciseInstructions.imageURL}
                            x-webkit-airplay="deny"
                            onError={(e) => {
                                console.error('Video playback error:', e);
                            }}
                        >
                            <source src={exerciseInstructions.videoURL} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : null}
                </div>

                {/* Text Instructions */}
                <div className='p-4 bg-gray-100 rounded-xl space-y-2'>
                    {exerciseInstructions.textInstructions && exerciseInstructions.textInstructions.trim() !== '' ? (
                        exerciseInstructions.textInstructions.split('\n').map((instruction, instructionIndex) => (
                            <p key={instructionIndex} className="text-left text-sm text-gray-600">
                                {instruction}
                            </p>
                        ))
                    ) : (
                        <p className="text-left text-sm text-gray-600 italic">No text instructions available</p>
                    )}
                </div>

                {/* Spacer for floating button */}
                <div className='w-full h-14 pt-8 pb-8' />

            </div>

            <div className='flex gap-x-4'>
                <div className='flex-1'>
                    <OutlineButton 
                        text="Back"
                        action={OnBackButton}
                    />
                </div>

                <div className='flex-1'>
                    <BrandColorButton 
                        text="Swap Exercise"
                        action={OnSwapExercise}
                    />
                </div>
            </div>
        </>
    )
}